// import HeaderHome from "./HeaderHome";
// import Newest from "./Newest";
import AvatarWithName from "@/components/AvatarWithName";
import { getRelativeTime } from "@/utils/datetime";
import { IReviewItem } from "Models";

import PopOver from "@/components/PopOver";
import { CommentTypeEnum } from "@/constants/enum/comment";
import {
  APP_BASE_URL,
  MEDIA_URL,
  STATIC_DOMAIN,
} from "@/constants/environment";
import { DEFAULT_IMAGE_CARD, DEFAULT_USER_AVATAR } from "@/constants/image";
import { ProjectContext } from "@/context/project.context";
import { useAuth } from "@/hooks/useAuth";
import ShareButton from "@components/Share";
import clsx from "clsx";
import dynamic from "next/dynamic";
import { useContext, useMemo } from "react";
import urlJoin from "url-join";
import BoxReply from "./BoxReply";
import FormReplyReview from "./ListReplyReview/FormReplyReview";
import ReviewDetailRate from "./ReviewDetailRate";
import ReviewDetailTextContent from "./ReviewDetailTextContent";
import { resizeOnFlyUrl } from "@/utils";

const ListReplyReview = dynamic(import("./ListReplyReview"), { ssr: false });

const ReviewDetailFileList = dynamic(import("./ReviewDetailFileList"), {
  ssr: false,
});
const ReviewDetailAction = dynamic(import("./ReviewDetailAction"), {
  ssr: false,
});
const ReviewItem = ({
  data,
  itemIndex,
  mounted,
}: {
  data: IReviewItem;
  isReply?: boolean;
  itemIndex?: number;
  mounted?: boolean;
}) => {
  const { currentShowFormReply, setCurrentShowFormReport, currentRefItem } =
    useContext(ProjectContext);
  const { user, login } = useAuth();

  const urlUserAvatar = useMemo(() => {
    if (data?.createdBy?.avatar) {
      return data?.createdBy?.avatar.includes(MEDIA_URL)
        ? resizeOnFlyUrl({
            uri: data?.createdBy?.avatar.replace(MEDIA_URL, ""),
            width: 64,
            height: 64,
            gravity: "ce",
            resizingType: "auto",
          })
        : data?.createdBy?.avatar;
    } else if (data?.nickName) {
      return null;
    } else return `${STATIC_DOMAIN}/${DEFAULT_USER_AVATAR}`;
  }, [data]);

  return (
    <div
      key={data._id}
      id={data._id}
      style={{
        boxShadow:
          "0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(0, 0, 0, 0.04)",
      }}
      ref={(ele: HTMLDivElement) => {
        currentRefItem.current[itemIndex] = ele;
      }}
      className="flex items-start gap-x-3 p-4 bg-white md:rounded-xl w-full overflow-auto border-b border-b-gray-200">
      <AvatarWithName
        imageClass="md:!w-14 md:!h-14 !w-8 !h-8"
        imageProps={{ resizeOnFly: false }}
        className="flex-0 "
        avatarOnly
        alt={data.nickName ? data.nickName : "Ẩn danh"}
        name={data.nickName}
        src={urlUserAvatar}
      />

      <div className="flex flex-col flex-1 gap-x-3 overflow-auto">
        <div className="flex-1">
          <div className="flex justify-between w-full">
            <div className="text-grey-700 font-semibold md:flex items-center flex-1 justify-start table-cell align-middle">
              <span className="md:line-clamp-1 break-word align-middle">
                {data.nickName ? data.nickName : "Ẩn danh"}{" "}
              </span>

              <span className="ml-1.5 text-grey-600 text-fs-14 font-normal whitespace-nowrap align-middle">
                {data.type === CommentTypeEnum.REVIEW
                  ? "đã viết review"
                  : "đã đặt câu hỏi"}
              </span>
              <i
                className={clsx(
                  "mrv  text-fs-24 text-grey-400  ml-1.5 cursor-pointe flex-0 align-middle",
                  data.type === CommentTypeEnum.REVIEW
                    ? "mrv-review"
                    : "mrv-contact_support"
                )}></i>
            </div>
            <div className="flex-0 flex gap-2">
              <ShareButton shareUrl={urlJoin(APP_BASE_URL, "review", data._id)}>
                <i className="mrv mrv-share text-fs-24 ml-1.5 cursor-pointer"></i>
              </ShareButton>
              <PopOver
                dropdownClassName="px-2 py-2.5 rounded-lg shadow-light-2"
                content={
                  <div>
                    <div
                      className="flex items-center w-56 cursor-pointer"
                      onClick={() =>
                        user ? setCurrentShowFormReport(data._id) : login()
                      }>
                      <i className="mrv mrv-report text-fs-20 mr-2 cursor-pointer"></i>
                      Báo cáo bài viết
                    </div>
                  </div>
                }>
                <i className="mrv mrv-more_vert text-fs-24 ml-1.5 cursor-pointer"></i>
              </PopOver>
            </div>
          </div>
          <div className="text-grey-500 text-fs-14">
            {mounted ? getRelativeTime(new Date(data?.publishedAt)) : null}
          </div>
        </div>

        <div className="w-full overflow-auto reply-review-list">
          <ReviewDetailRate data={data} />
          <ReviewDetailTextContent data={data} />
          <ReviewDetailFileList data={data} />
          <ReviewDetailAction data={data} />
          {currentShowFormReply ? null : <BoxReply data={data} />}
          {currentShowFormReply === data._id ? (
            <FormReplyReview
              data={data}
              reviewItem={data}
              reviewIndex={itemIndex}
            />
          ) : null}

          {<ListReplyReview data={data} reviewIndex={itemIndex} />}
        </div>
      </div>
    </div>
  );
};

export default ReviewItem;
